import React, { useCallback } from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useAppContext } from "src/providers/AppProvider";
import Modal from "src/components/Modal";
import Button from "@material-ui/core/Button/Button";
import { useStyles } from "src/components/Modal/toggleModalBaseStyles";
import { useSellersContext } from "src/providers/SellersStore";

interface Props {
  onActivate?: () => void;
}

const ActivateSellerModal = ({ onActivate }: Props) => {
  const {
    sellersStore: { loading },
    callAPI: { activateSellers },
  } = useSellersContext();

  const {
    state: {
      modals: { sellersActivateModal },
      modalsCtx,
    },
    callAppAPI: { toggleModal },
  } = useAppContext();

  const closeModal = useCallback(() => {
    toggleModal({ id: "sellersActivateModal", status: false });
  }, []);

  const onSubmit = async () => {
    if (!modalsCtx.sellersActivateModal || !modalsCtx.sellersActivateModal.seller.key) {
      console.error("seller is not found");

      return;
    }

    const { seller } = modalsCtx.sellersActivateModal;

    await activateSellers([seller.key!]);
    if (onActivate) onActivate();
    closeModal();
  };

  const { actions, heading, submitBtn, cancelBtn } = useStyles();
  const { t } = useTranslation("sellers");

  if (!modalsCtx.sellersActivateModal || !modalsCtx.sellersActivateModal.seller.name) {
    return null;
  }

  return (
    <Modal isOpen={sellersActivateModal} onClose={closeModal}>
      <>
        <header className={heading}>
          <Typography variant="h3">
            {t("toggle_active.activate_title", {
              name: modalsCtx.sellersActivateModal.seller.name,
            })}
          </Typography>
        </header>
        <section className={actions}>
          <Button type="submit" onClick={onSubmit} className={submitBtn}>
            {loading ? (
              <CircularProgress size={18} color="secondary" />
            ) : (
              t("toggle_active.activate_action")
            )}
          </Button>
          <Button onClick={closeModal} className={cancelBtn}>
            {t("cancel", { ns: "common" })}
          </Button>
        </section>
      </>
    </Modal>
  );
};

export default ActivateSellerModal;
